<script>
//it says legacy mode in VSO because runes are not needed hence not used
import dayjs from 'dayjs';
import { format, locale } from 'svelte-i18n';

let year = dayjs().year();
</script>
<footer class="app-footer footer vlsk-bg-white">
    <div class="container-fluid text-center">
        <span>{@html $format('layout.footer.text', { values: { year } })}</span>
    </div>
    <div class="container-fluid text-center">
        {#if $locale == 'es'}
            <a href="#" data-bs-toggle="modal" data-bs-target="#modalTermsAndConditions">Términos y condiciones</a> - <a href="mailto:vulseek@securetia.com?subject='NOTICE AND TAKEDOWN'">Notice and takedown</a>
        {/if}
        {#if $locale == 'en'}
            <a href="#" data-bs-toggle="modal" data-bs-target="#modalTermsAndConditions">Terms and conditions</a> - <a href="mailto:vulseek@securetia.com?subject='NOTICE AND TAKEDOWN'">Notice and takedown</a>
        {/if}
    </div>
</footer>
<style>
    footer {
        height: 75px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 1.5;
    }
    span{
        font-size: 14px;
    }
    i{
        font-size: 20px;
        margin-top: 1px;
    }
    .fab.fa-instagram:hover,
    .fab.fa-facebook:hover{
        opacity: 0.8;
    }
</style>